module.exports = __webpack_public_path__ + "img/icon-refresh-light.e38cbd82.svg";